<template>
  <div id="app">
    <h2>数字生态指数管理平台</h2>
    <div id="form">
      <i-form ref="formInline" :model="formInline" :rules="ruleInline" inline>
        <i-formItem prop="user">
          <i-input
            type="text"
            v-model="formInline.user"
            placeholder="请输入手机号"
            @keyup.enter.native="handleSubmit('formInline')"
            style="width:600px"
          >
            <span class="iconfont" slot="prepend">&#xe612;</span>
          </i-input>
        </i-formItem>
        <br />
        <i-formItem prop="password">
          <i-input
            type="password"
            v-model="formInline.password"
            placeholder="密码"
            @keyup.enter.native="handleSubmit('formInline')"
            style="width:600px"
          >
            <span class="iconfont" slot="prepend">&#xe640;</span>
          </i-input>
        </i-formItem>
        <br />
        <i-formItem>
          <i-button type="primary" @click="handleSubmit('formInline')" style="width:600px">登录</i-button>
        </i-formItem>
        <br />
      </i-form>
      <div id="tip">
        <span>还没有账户？</span>
        <span id="span2"><a href="/register">注册账户</a></span>
      </div>
    </div>
    <div class="link">
      <a :href="EXTERNAL_LINK">
        技术支持
      </a>
    </div>
  </div>
</template>
<script>
import { KeFuMixin } from "../common/mixin"

export default {
  mixins: [KeFuMixin],
  data() {
    return {
      formInline: {
        user: "",
        password: "",
      },
      ruleInline: {
        user: [{ required: true, message: "请填写账号", trigger: "blur" }],
        password: [
          { required: true, message: "请填写密码", trigger: "blur" },
          { type: "string", min: 3, message: "密码长度不能小于6位", trigger: "blur" },
        ],
      },
      prevRoute: "",
      EXTERNAL_LINK: process.env.VUE_APP_EXTERNAL_LINK,
    }
  },
  methods: {
    //判断是否提交成功
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        const self = this
        if (valid) {
          const params = {
            account: self.formInline.user,
            password: self.formInline.password,
          }
          this.axios({
            method: "post",
            url: self.$store.state.baseurl + "api/system/login",
            params: params,
          }).then((res) => {
            if (!res) {
              return
            }
            if (res.data.code === 0) {
              this.setCookie("login", "true")
              this.$Message.success("登录成功!")
              self.$router.push(self.prevRoute)
            } else {
              self.$Message.error(res.data.error_message)
            }
          })
        } else {
          this.$Message.error("表单验证失败!")
        }
      })
    },
  },
  beforeRouteEnter(to, from, next) {
    console.log(from)
    next((vm) => {
      vm.prevRoute = from
    })
  },
}
</script>
<style scoped>
#app {
  position: relative;
  margin: 0 auto;
}
.link{
  margin-top: 20px;
}
#app h2 {
  text-align: center;
  color: #202891;
  font-size: 43px;
  padding: 150px 0 0;
  position: relative;
}
#form {
  text-align: center;
  margin: 20px 0 0;
  position: relative;
}
#tip {
  width: 600px;
  position: relative;
  margin: -10px auto;
  display: flex;
  justify-content: space-between;
}
</style>
